import { render, staticRenderFns } from "./CreditHoldStatus.vue?vue&type=template&id=08d37cdc&scoped=true"
import script from "./CreditHoldStatus.vue?vue&type=script&lang=js"
export * from "./CreditHoldStatus.vue?vue&type=script&lang=js"
import style0 from "./CreditHoldStatus.vue?vue&type=style&index=0&id=08d37cdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d37cdc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
